class DotoCategoryMenuV3 {
  constructor(shell) {
    this.shell = shell;
    this.groups = Array.from(shell.querySelectorAll('[data-doto-category-accordion]'));
    this.drawerOpenButton = shell.querySelector('[data-doto-drawer-open]');
    this.desktopMedia = window.matchMedia('(min-width: 992px)');

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.onDrawerOpen = this.onDrawerOpen.bind(this);

    this.bind();
    this.resetForViewport();
  }

  bind() {
    this.groups.forEach((group) => {
      group.querySelector('[data-doto-category-toggle]')?.addEventListener('click', this.onToggleClick);
    });
    this.desktopMedia.addEventListener?.('change', this.onBreakpointChange);
    this.drawerOpenButton?.addEventListener('click', this.onDrawerOpen);
  }

  onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    const group = button.closest('[data-doto-category-accordion]');
    if (!group) return;

    this.setGroupOpen(group, !group.classList.contains('is-open'));
  }

  setGroupOpen(group, open) {
    const button = group.querySelector('[data-doto-category-toggle]');
    const panel = group.querySelector('[data-doto-category-panel]');

    group.classList.toggle('is-open', open);
    button?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  resetForViewport() {
    this.groups.forEach((group) => {
      const mode = group.dataset.categoryMode;
      if (mode === 'desktop') {
        this.setGroupOpen(group, this.desktopMedia.matches);
      } else if (mode === 'mobile') {
        this.setGroupOpen(group, false);
      }
    });
  }

  closeMobileGroups() {
    this.groups.forEach((group) => {
      if (group.dataset.categoryMode === 'mobile') this.setGroupOpen(group, false);
    });
  }

  onDrawerOpen() {
    this.closeMobileGroups();
  }

  onBreakpointChange() {
    this.resetForViewport();
  }

  destroy() {
    this.groups.forEach((group) => {
      group.querySelector('[data-doto-category-toggle]')?.removeEventListener('click', this.onToggleClick);
    });
    this.desktopMedia.removeEventListener?.('change', this.onBreakpointChange);
    this.drawerOpenButton?.removeEventListener('click', this.onDrawerOpen);
  }
}

const dotoCategoryMenuV3Instances = new Map();

function initDotoCategoryMenuV3(shell) {
  if (!shell || dotoCategoryMenuV3Instances.has(shell)) return;
  dotoCategoryMenuV3Instances.set(shell, new DotoCategoryMenuV3(shell));
}

function destroyDotoCategoryMenuV3(shell) {
  dotoCategoryMenuV3Instances.get(shell)?.destroy();
  dotoCategoryMenuV3Instances.delete(shell);
}

document.querySelectorAll('[data-doto-site-header-shell]').forEach(initDotoCategoryMenuV3);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll?.('[data-doto-site-header-shell]').forEach(initDotoCategoryMenuV3);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll?.('[data-doto-site-header-shell]').forEach(destroyDotoCategoryMenuV3);
});
